const displayScore = ()  => {

  setTimeout(() => {
    if (document.querySelector('.action-next')) { document.querySelector('.action-next').classList.remove('visually-hidden') };
  }, 1600);
}

export { displayScore };
